import cacher from "./../js-lib/cacher.js";

import Theme from "./DefaultModal/Theme.js";
import Eco from "./DefaultModal/Eco.js";
import Images from "./DefaultModal/Images.js";
import HighEnergy from "./DefaultModal/HighEnergy.js";
import Stylesheet from "./DefaultModal/Stylesheet.js";

const DefaultModal = {
  load_cache: (state) => {
    // Default Modal Cache
    state["DefaultModal"] = cacher.retrieve("DefaultModal")
      ? cacher.retrieve("DefaultModal")
      : state.DefaultModal;

    // Theme.load_cache(state);
    // Eco.load_cache(state);
  },
  global_scope: (state) => {
    // Show / Hide Modal
    //toggler.toggle(lib.qsa('.global-js--DefaultModal-toggle'), state.DefaultModal, DefaultModal.render.bind(this, state))
    // Theme.global_scope(state, DefaultModal.render);
    // Eco.global_scope(state, DefaultModal.render);
  },
  scope: (state) => {
    Theme.scope(state);
    Stylesheet.render(state);

    // Do not render if closed
    if (state.DefaultModal.current == state.DefaultModal.opt[1]) {
      // Eco.render(state);
      // Theme.render(state);
    }

    Images.observer(state);
    HighEnergy.render(state);
  },
  render: (state) => {
    // if(state.theme.current == 'light') {
    //     state.eco.current = 'disabled'
    //     Eco.render(state);
    // }

    // if (state.eco.current == "enabled" && state.theme.current == "light") {
    //   Eco.off(state);
    //   Theme.off(state);
    //   state.refresh = true;
    // }

    // if (state.eco.current == "disabled" && state.theme.current == "light") {
    //   Eco.off(state);
    //   Theme.off(state);
    //   state.refresh = true;
    // }

    // if (state.eco.current == "enabled") {
    //   Theme.on(state);
    // }

    setTimeout(() => {
      if (state.refresh == true) {
        location.reload();
      }
    }, 100);

    // Render People Profile State
    //toggler.render(lib.qsa('.global-js--DefaultModal-toggle'), state.DefaultModal)

    // Store Cached Items
    cacher.store("DefaultModal", state.DefaultModal);
  },
};

export { DefaultModal as default };
